//import index from './index.vue'
import index from "./indexNew.vue";
export default index;
